import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import TestPaper from '../entities/testPaper'
import Cascader from '../entities/cascader'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';

interface QuestionOfPapersState extends ListState<TestPaper> {
    editTestPaper: TestPaper;
    cascaders: any;
    params:string;
}
class QuestionOfPapersModule extends ListModule<QuestionOfPapersState, any, TestPaper>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<TestPaper>(),
        loading: false,
        editTestPaper: new TestPaper(),
        cascaders: new Array<Cascader>(),
        params:""
    }
    actions = {
        async getAll(context: ActionContext<QuestionOfPapersState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/TestPaper/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<TestPaper>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<QuestionOfPapersState, any>, payload: any) {
            await Ajax.post('/api/services/app/TestPaper/Create', payload.data);
        },
        async update(context: ActionContext<QuestionOfPapersState, any>, payload: any) {
            await Ajax.put('/api/services/app/TestPaper/Update', payload.data);
        },
        async delete(context: ActionContext<QuestionOfPapersState, any>, payload: any) {
            await Ajax.delete('/api/services/app/TestPaper/Delete?Id=' + payload.data.id);
        },
        async auditedTestPaper(context: ActionContext<QuestionOfPapersState, any>, payload: any) {
            // context.state.loading = true;
            await Ajax.post('/api/services/app/TestPaper/Review', payload.data);
            //  context.state.loading = false;
        },
        async get(context: ActionContext<QuestionOfPapersState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/TestPaper/Get?Id=' + payload.data.id);
            // return reponse.data.result as TestPaper;
            context.state.editTestPaper = reponse.data.result as TestPaper
        },
        async getCascader(context: ActionContext<QuestionOfPapersState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetCascaderList', { params: payload.data });
            context.state.cascaders = reponse.data.result as Array<Cascader>;
            context.state.loading = false;
        },
        async showStateSwitching(context: ActionContext<QuestionOfPapersState, any>, payload: any) {
            await Ajax.post('/api/services/app/TestPaper/Activation', payload.data);
            // context.state.editTestPaper = reponse.data.result as TestPaper
        },
        async importQuestion(context: ActionContext<QuestionOfPapersState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/TestPaper/ImprotQuestionOfPaper', payload.data);
            context.state.editTestPaper = reponse.data.result as TestPaper
        },
        async review(context: ActionContext<QuestionOfPapersState, any>, payload: any) {
             await Ajax.post('/api/services/app/TestPaper/Review', payload.data);
        }
    };
    mutations = {
        setCurrentPage(state: QuestionOfPapersState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: QuestionOfPapersState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: QuestionOfPapersState, testPaper: TestPaper) {
            state.editTestPaper = testPaper;
        },
        param(state: QuestionOfPapersState, params: string) {
            state.params = params;
        }
    }
}
const questionOfPapersModule = new QuestionOfPapersModule();
export default questionOfPapersModule;